import { GenIcon } from "../iconBase";

export function IoChevronDown(props) {
    return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "48", "d": "M112 184l144 144 144-144" } }] })(props);
};